[
 {
  "title": "A hora é essa",
  "description": "Corrido",
  "lyrics": [
   {
    "pt": "[Coro] A hora é essa, a hora é essa\nA hora é essa, a hora é essa",
    "en": "[Chorus] Now is the time, now is the time\nNow is the time, now is the time"
   },
   {
    "pt": "Berimbau tocou na capoeira\nBerimbau tocou, eu vou jogar",
    "en": "The berimbau sounded in capoeira\nThe berimbau sounded; I’m going to play"
   },
   {
    "pt": "[Coro] Berimbau tocou na capoeira\nBerimbau tocou, eu vou jogar",
    "en": "[Chorus] The berimbau sounded in capoeira\nThe berimbau sounded; I’m going to play"
   }
  ],
  "recordings": [
   {
    "label": "Carolina Soares & Mestrando Bigodinho",
    "url": "https://www.youtube.com/watch?v=dKzpMdJQUgQ"
   },
   {
    "label": "Carolina Soares · lyric video",
    "url": "https://www.youtube.com/watch?v=LKrNJupmVNM"
   },
   {
    "label": "Mestre Bigodinho",
    "url": "https://www.youtube.com/watch?v=rFjAF75DvzA"
   }
  ],
  "source": {
   "label": "Maple Valley Capoeira",
   "url": "https://www.maplevalleycapoeira.com/capoeira-songbook/a-hora-e-essa-vai-la/"
  }
 },
 {
  "title": "Adeus povo bom",
  "description": "Corrido",
  "lyrics": [
   {
    "pt": "[Coro] Adeus, povo bom, adeus\nAdeus, eu já vou me embora\nPelas ondas do mar eu vim\nPelas ondas do mar\nEu vou me embora",
    "en": "[Chorus] Goodbye, good people, goodbye\nGoodbye, I’m leaving now\nBy the waves of the sea I came\nBy the waves of the sea\nI’m leaving"
   }
  ],
  "recordings": [
   {
    "label": "Chant Capoeira",
    "url": "https://www.youtube.com/watch?v=l324w4s4PNc"
   }
  ],
  "source": {
   "label": "The Capoeira Cafe",
   "url": "https://www.capoeira.cafe/adeus-povo-bom/"
  }
 },
 {
  "title": "Agora Sim Quem Mataram Meu Besouro",
  "description": "Corrido",
  "lyrics": [
   {
    "pt": "Agora sim, que mataram o meu Besouro\nDepois de morto, Besourinho cordão de ouro",
    "en": "Now, now that they killed my Besouro\nAfter death, little Besouro of the golden cord"
   },
   {
    "pt": "[Coro] Ô Besouro Besourinho\nCordão de Ouro\nÔ Besouro Besourinho\nCordão de Ouro",
    "en": "[Chorus] Oh Besouro, little Besouro\nGolden cord\nOh Besouro, little Besouro\nGolden cord"
   }
  ],
  "recordings": [
   {
    "label": "Mestre Jogo de Dentro",
    "url": "https://www.youtube.com/watch?v=cn5qE4mpReo"
   },
   {
    "label": "With practice track",
    "url": "https://www.youtube.com/watch?v=LPhEZAlTs9s"
   }
  ],
  "source": {
   "label": "Capoeira Aché Brasil Calgary",
   "url": "https://capoeiraabc.com/2021/03/17/agora-sim-que-mataram-o-meu-besouro/"
  }
 },
 {
  "title": "Bahia axé, axé Bahia",
  "description": "Corrido",
  "lyrics": [
   {
    "pt": "Que bom\nEstar com vocês\nAqui nessa roda\nCom este conjunto",
    "en": "How good it is\nTo be here with you all\nHere in this roda\nWith this group"
   },
   {
    "pt": "[Refrão] Bahia axé, axé Bahia\nBahia axé, axé Bahia",
    "en": "[Refrain] Bahia axé, axé Bahia\nBahia axé, axé Bahia"
   },
   {
    "pt": "[Refrão] Io ioioioioo\nIoioioo\nIoioioo",
    "en": "[Refrain] Io ioioioioo\nIoioioo\nIoioioo"
   },
   {
    "pt": "O vento\nQue venta tão lindo\nEntre os coqueirais\nIsso é demais",
    "en": "The wind\nThat blows so beautifully\nAmong the coconut palms\nThis is wonderful"
   },
   {
    "pt": "[Refrão] Bahia axé, axé Bahia\nBahia axé, axé Bahia",
    "en": "[Refrain] Bahia axé, axé Bahia\nBahia axé, axé Bahia"
   },
   {
    "pt": "[Refrão] Io ioioioioo\nIoioioo\nIoioioo",
    "en": "[Refrain] Io ioioioioo\nIoioioo\nIoioioo"
   }
  ],
  "recordings": [
   {
    "label": "Bahia axé · video",
    "url": "https://www.youtube.com/watch?v=RixwE3H1vto"
   }
  ],
  "source": {
   "label": "Aprenda Capoeira",
   "url": "https://www.aprenda-capoeira.fr/cantigas/"
  }
 },
 {
  "title": "Beira mar ioiô",
  "description": "Corrido",
  "lyrics": [
   {
    "pt": "Beira mar ioiô\nBeira mar iaiá\nBeira mar ioiô\nBeira mar iaiá",
    "en": "By the sea, ioiô\nBy the sea, iaiá\nBy the sea, ioiô\nBy the sea, iaiá"
   },
   {
    "pt": "Beira mar, beira mar\nÉ de ioiô\nBeira mar, beira mar\nÉ de iaiá",
    "en": "By the sea, by the sea\nIt is ioiô's\nBy the sea, by the sea\nIt is iaiá's"
   }
  ],
  "recordings": [
   {
    "label": "The Capoeira Life · with lyrics",
    "url": "https://www.youtube.com/watch?v=oICNkDgQgLY"
   },
   {
    "label": "La Laue Capoeira",
    "url": "https://www.youtube.com/watch?v=499py7R8ciw"
   }
  ],
  "source": {
   "label": "Beira Mar songsheet (PDF)",
   "url": "https://img1.wsimg.com/blobby/go/0b14e090-a5b0-412b-9da4-1e565db20416/downloads/Beira%20Mar.pdf?ver=1761619767864"
  }
 },
 {
  "title": "Berimbau falou",
  "description": "Corrido",
  "lyrics": [
   {
    "pt": "[Coro] Falou, falou da escravidão, falou\nFalou, falou da opressão, falou\nFalou, lá nos tempos de Bimba, falou\nFalou, hoje se escutou",
    "en": "[Chorus] It spoke, spoke of slavery, it spoke\nIt spoke, spoke of oppression, it spoke\nIt spoke, back in Bimba’s time, it spoke\nIt spoke; today it was heard"
   },
   {
    "pt": "O negro que sofria na senzala\nTrabalhava na fazenda do feitor\nE um dia ele escutou um lamento\nEra Zumbi dos Palmares\nFoi ele quem libertou\nHoje falou",
    "en": "The Black man who suffered in the slave quarters\nWorked on the overseer’s plantation\nAnd one day he heard a lament\nIt was Zumbi dos Palmares\nHe was the one who brought freedom\nToday it spoke"
   },
   {
    "pt": "Berimbau ajudava os capoeiras\nLá no tempo, lá no tempo da opressão\nSe escutava o toque de Cavalaria\nQuando a polícia seguia\nBerimbau já me avisou\nHoje falou",
    "en": "The berimbau helped the capoeiristas\nBack then, in the time of oppression\nThe Cavalaria rhythm could be heard\nWhen the police were approaching\nThe berimbau had already warned me\nToday it spoke"
   },
   {
    "pt": "Manuel foi o mestre respeitado\nCriador da arte da Regional\nHoje em dia seu nome será lembrado\nJá não se esqueceu do homem\nQue a capoeira falou\nHoje falou",
    "en": "Manuel was the respected mestre\nCreator of the art of Regional\nToday his name will be remembered\nThe man whom capoeira spoke of\nHas not been forgotten\nToday it spoke"
   },
   {
    "pt": "Histórias que se narram do passado\nJogadores que se escutam até hoje\nE os cantos que me levam pelos tempos\nLembrando esses momentos\nOnde o berimbau tocou\nHoje falou",
    "en": "Stories told from the past\nPlayers we still hear about today\nAnd the songs that carry me through time\nRemembering those moments\nWhen the berimbau played\nToday it spoke"
   }
  ],
  "recordings": [
   {
    "label": "Graduado Voador",
    "url": "https://youtube.com/watch?v=w0JjFezi6Io&si=2c1J3Y41YqHubk-W"
   },
   {
    "label": "Capoeira Nagô",
    "url": "https://www.youtube.com/watch?v=ZMDVOuJIvtc"
   },
   {
    "label": "Lyrics & translation study version",
    "url": "https://www.youtube.com/watch?v=RRtow8_krFU"
   }
  ],
  "source": {
   "label": "The Capoeira Cafe",
   "url": "https://capoeira.cafe/berimbau-falou/"
  }
 },
 {
  "title": "Boa Noite",
  "description": "Maculelê",
  "lyrics": [
   {
    "pt": "[Abertura] O boa noite pra quem é de boa noite\nO bom dia pra quem é de bom dia\nA benção meu papai a benção\nMaculêlê é o rei da valentia",
    "en": "[Opening] Good evening to those who deserve good evening\nGood morning to those who deserve good morning\nBless me, my father, bless me\nMaculelê is the king of bravery"
   },
   {
    "pt": "Tindolelê auê Cauiza\nTindolelê é sangue real\nEu sou filho eu sou nego de Aruanda\nTindolelê auê Cauiza",
    "en": "Tindolelê auê Cauiza\nTindolelê is royal blood\nI am a son, I am a Black man from Aruanda\nTindolelê auê Cauiza"
   },
   {
    "pt": "[Chamada e resposta] E Cauiza, de onde e que veio\nEu vim de Angola ê\nMaculelê, de onde e que veio\nEu vim de Angola ê\nE o atabaque, de onde e que veio\nEu vim de Angola ê\nSarará, de onde e que veio\nEu vim de Angola ê\nE o agogô, de onde e que veio\nEu vim de Angola ê",
    "en": "[Call and response] And Cauiza, where did you come from\nI came from Angola\nMaculelê, where did you come from\nI came from Angola\nAnd the atabaque, where did it come from\nI came from Angola\nSarará, where did you come from\nI came from Angola\nAnd the agogô, where did it come from\nI came from Angola"
   }
  ],
  "recordings": [
   {
    "label": "Biriba · Ramón Villanueva",
    "url": "https://www.youtube.com/watch?v=iAnPFJ6enRE"
   },
   {
    "label": "Maculelê songs medley",
    "url": "https://www.youtube.com/watch?v=AaMMZA0Fhe8"
   }
  ],
  "source": {
   "label": "Berimbrown on Letras.mus.br",
   "url": "https://www.letras.mus.br/berimbrown/1139193/"
  }
 },
 {
  "title": "É amor demais",
  "description": "Corrido",
  "lyrics": [
   {
    "pt": "[Coro] É amor demais\nFaz parte de mim\nA capoeira\nTem começo e não tem fim",
    "en": "[Chorus] It’s so much love\nIt’s part of me\nCapoeira\nHas a beginning and no end"
   },
   {
    "pt": "Quando eu vi o berimbau\nEu me apaixonei por ela\nSe tornou a minha vida\nComo a arte mais bela",
    "en": "When I saw the berimbau\nI fell in love with capoeira\nIt became my life\nAs the most beautiful art"
   },
   {
    "pt": "[Coro] É amor demais\nFaz parte de mim\nA capoeira\nTem começo e não tem fim",
    "en": "[Chorus] It’s so much love\nIt’s part of me\nCapoeira\nHas a beginning and no end"
   },
   {
    "pt": "Se tornou o meu viver\nA minha filosofia\nVou honrar a capoeira\nEnquanto eu tiver vida",
    "en": "It became my way of life\nMy philosophy\nI will honor capoeira\nAs long as I live"
   },
   {
    "pt": "[Coro] É amor demais\nFaz parte de mim\nA capoeira\nTem começo e não tem fim",
    "en": "[Chorus] It’s so much love\nIt’s part of me\nCapoeira\nHas a beginning and no end"
   },
   {
    "pt": "Quem sabe da capoeira\nSabe que é mesmo assim\nSabe que ela tem começo\nMas ninguém sabe seu fim",
    "en": "Whoever knows capoeira\nKnows that’s how it is\nKnows that it has a beginning\nBut no one knows its end"
   }
  ],
  "recordings": [
   {
    "label": "Abadá Capoeira",
    "url": "https://www.youtube.com/watch?v=Cdymym43LmQ"
   },
   {
    "label": "Capoeira version 2",
    "url": "https://www.youtube.com/watch?v=iBUAFBtPSCE"
   },
   {
    "label": "Capoeira version 3",
    "url": "https://www.youtube.com/watch?v=fgNgkKL6xJs"
   }
  ],
  "source": {
   "label": "Aprenda Capoeira",
   "url": "https://www.aprenda-capoeira.fr/cantigas/e-amor-de-mais"
  }
 },
 {
  "title": "Essa noite eu sonhei",
  "description": "Corrido",
  "lyrics": [
   {
    "pt": "[Coro] Essa noite eu sonhei\nQuase acreditei\nQue um dia seu Bimba\nVinha me visitar\nFoi um sonho, eu sei\nMuito triste eu fiquei\nSe eu pudesse do sonho\nNão iria acordar",
    "en": "[Chorus] Last night I dreamed\nI almost believed\nThat one day Mestre Bimba\nWould come to visit me\nIt was a dream, I know\nI was very sad\nIf I could stay in that dream\nI would not wake up"
   },
   {
    "pt": "Ele vinha de branco\nOlhar bem fechado, com seu berimbau\nCantou logo uma quadra e um corrido da sua Regional\nDepois sumiu com o vento\nE se espalhou todo pelo ar",
    "en": "He came dressed in white\nWith a guarded gaze and his berimbau\nHe sang a quadra and a corrido from his Regional tradition\nThen he vanished with the wind\nAnd spread through the air"
   },
   {
    "pt": "[Coro] Mestre Bimba está\nAonde berimbau tocar",
    "en": "[Chorus] Mestre Bimba is\nWherever the berimbau plays"
   }
  ],
  "recordings": [
   {
    "label": "Mestre Cabeça",
    "url": "https://www.youtube.com/watch?v=9Zgc2A3UKkU"
   }
  ],
  "source": {
   "label": "Dendê Arts",
   "url": "https://dendearts.com/blog/essa-noite-eu-sonhei/"
  }
 },
 {
  "title": "Fui lá na Bahia buscar coco de dendê",
  "description": "Corrido",
  "lyrics": [
   {
    "pt": "Fui lá na Bahia\nBuscar coco de dendê\nFui lá na Bahia\nBuscar coco de dendê",
    "en": "I went there to Bahia\nTo fetch dendê coconut\nI went there to Bahia\nTo fetch dendê coconut"
   },
   {
    "pt": "Você é bom capoeira\nJoga aí que eu quero ver\nVocê é bom capoeira\nJoga aí que eu quero ver",
    "en": "You are a good capoeirista\nPlay, I want to see\nYou are a good capoeirista\nPlay, I want to see"
   },
   {
    "pt": "Do terreiro de Ioió\nDo terreiro de Iaiá\nDo terreiro de Ioió\nDo terreiro de Iaiá",
    "en": "From the yard of Ioiô\nFrom the yard of Iaiá\nFrom the yard of Ioiô\nFrom the yard of Iaiá"
   },
   {
    "pt": "Capoeira começa ao anoitecer\nVai até o sol raiar\nCapoeira começa ao anoitecer\nVai até o sol raiar",
    "en": "Capoeira starts at nightfall\nAnd goes until the sun rises\nCapoeira starts at nightfall\nAnd goes until the sun rises"
   },
   {
    "pt": "O no som do berimbau\nO pandeiro vai marcar\nO no som do berimbau\nO pandeiro vai marcar",
    "en": "Oh, to the sound of the berimbau\nThe pandeiro will keep the beat\nOh, to the sound of the berimbau\nThe pandeiro will keep the beat"
   }
  ],
  "recordings": [
   {
    "label": "Capoeira Ritmo Baiano",
    "url": "https://www.youtube.com/watch?v=JHAlvNS-i50"
   }
  ],
  "source": {
   "label": "Dendê Arts",
   "url": "https://dendearts.com/blog/fui-la-na-bahia-buscar-coco-de-dende/"
  }
 },
 {
  "title": "Lenda Viva (Mandei caiá meu sobrado)",
  "description": "Corrido",
  "lyrics": [
   {
    "pt": "Mandei, caiá meu sobrado\nMandei, mandei, mandei\nMandei caiá de amarelo\nCaiei, caiei, caiei",
    "en": "I ordered my sobrado whitewashed\nI ordered it, I ordered it, I ordered it\nI ordered it whitewashed in yellow\nWhitewash it, whitewash it, whitewash it"
   },
   {
    "pt": "Amarelo que lembra dourado\nDourado, que é meu berimbau\nDourado, de cordão de ouro\nBesouro, Besouro, Besouro",
    "en": "Yellow that recalls gold\nGolden, like my berimbau\nGolden, with a cord of gold\nBesouro, Besouro, Besouro"
   },
   {
    "pt": "Pra quem nunca ouviu falar\nPra aqueles que dizem: que é lenda!\nPois saibam que Besouro preto\nViveu, viveu e morreu!",
    "en": "For those who never heard\nFor those who say it is a legend!\nKnow that Besouro, the Black man\nLived, lived and died!"
   },
   {
    "pt": "Pras bandas de Maracangalha,\nSem temer a inimigo nenhum\nNão valeu, seu corpo fechado\nPra faca de aticum!",
    "en": "Over in the Maracangalha region,\nWithout fearing any enemy\nHis closed body was no use\nAgainst the aticum knife!"
   },
   {
    "pt": "Mas mesmo depois de morto\nEntre uma e outra cantiga\nBesouro vai sempre viver\nEnquanto existir mandinga",
    "en": "But even after death\nBetween one song and another\nBesouro will always live\nAs long as mandinga exists"
   },
   {
    "pt": "[Coro] Mandei, caiá meu sobrado\nMandei, mandei, mandei\nMandei caiá de amarelo\nCaiei, caiei, caiei!",
    "en": "[Chorus] I ordered my sobrado whitewashed\nI ordered it, I ordered it, I ordered it\nI ordered it whitewashed in yellow\nWhitewash it, whitewash it, whitewash it!"
   }
  ],
  "recordings": [
   {
    "label": "Abadá-Capoeira",
    "url": "https://www.youtube.com/watch?v=tdW1xqAfB2s"
   },
   {
    "label": "Mestre Casquinha version",
    "url": "https://www.youtube.com/watch?v=fNCKUz_kaf0"
   }
  ],
  "source": {
   "label": "Lelé's Capoeira Blog",
   "url": "https://lelecapoeira.com/2015/mandei-caia-meu-sobrado/"
  }
 },
 {
  "title": "Mandei Benzer Mandei Rezar",
  "description": "Corrido",
  "lyrics": [
   {
    "pt": "[Coro] Mandei benzer, mandei, mandei rezar\nMandei benzer, mandei, mandei rezar",
    "en": "[Chorus] I had it blessed; I had prayers said\nI had it blessed; I had prayers said"
   },
   {
    "pt": "[Verso] Uma prece por Capoeira\nQue não sabe vadiar\nUma prece por Capoeira\nQue não sabe vadiar",
    "en": "[Verse] A prayer for the capoeirista\nWho doesn’t know how to play\nA prayer for the capoeirista\nWho doesn’t know how to play"
   },
   {
    "pt": "[Chamada] Olha tira daqui, bota ali\nOlha tira de lá, bota cá",
    "en": "[Call] Look, take it from here, put it there\nLook, take it from there, put it here"
   },
   {
    "pt": "[Final] Mandei benzer, mandei rezar\nMandei, mandei benzer\nMandei, mandei rezar",
    "en": "[Ending] I had it blessed; I had prayers said\nI had it, had it blessed\nI had it, had prayers said"
   }
  ],
  "recordings": [
   {
    "label": "Sinistro Capoeira Música",
    "url": "https://www.youtube.com/watch?v=kPefzZDYvlk"
   }
  ],
  "source": {
   "label": "Sinistro on Bandcamp",
   "url": "https://sinistrocapoeiramusica.bandcamp.com/track/hoje-a-lua-quebrou-no-meio-mandei-benzer"
  }
 },
 {
  "title": "Mandei benzer meu berimbau",
  "description": "Corrido",
  "lyrics": [
   {
    "pt": "[Coro] Mandei, mandei benzer\nMandei benzer meu berimbau\nNa capela\nMandei",
    "en": "[Chorus] I ordered, I ordered it blessed\nI had my berimbau blessed\nIn the chapel\nI ordered it"
   },
   {
    "pt": "Tocava meu berimbau\nQuando o arame se quebrou\nEra sinal de coisa ruim\nMas eu não quis acreditar\nToda vez que eu tocava o berimbau\nO arame voltava a se quebrar\nEu levei meu berimbau\nNuma capela pra benzer\nE pedi para São Bento\nDo mal vir me proteger",
    "en": "I was playing my berimbau\nWhen the wire snapped\nIt was a sign of bad things\nBut I did not want to believe it\nEvery time I played the berimbau\nThe wire would snap again\nI took my berimbau\nTo a chapel to have it blessed\nAnd I asked São Bento\nTo come protect me from evil"
   },
   {
    "pt": "[Coro] Mandei, mandei benzer\nMandei benzer meu berimbau\nNa capela\nMandei",
    "en": "[Chorus] I ordered, I ordered it blessed\nI had my berimbau blessed\nIn the chapel\nI ordered it"
   },
   {
    "pt": "Eu pedi pra São Bento (benzer)\nEu pedi pra São Bento (guardar)\nEu pedi pra São Bento (benzer)\nOi, meu berimbau eu vou tocar",
    "en": "I asked São Bento (bless it)\nI asked São Bento (guard it)\nI asked São Bento (bless it)\nHey, I am going to play my berimbau"
   }
  ],
  "recordings": [
   {
    "label": "Mestre Barrão",
    "url": "https://www.youtube.com/watch?v=3gd0TOUpwIY"
   },
   {
    "label": "Mestre Barrão Oficial",
    "url": "https://www.youtube.com/watch?v=CLPyQ7W6lU8"
   }
  ],
  "source": {
   "label": "Letras.mus.br · Mestre Barrão",
   "url": "https://www.letras.mus.br/mestre-barrao/mandei-benzer-meu-berimbau/"
  }
 },
 {
  "title": "Meu Patuá",
  "description": "Corrido",
  "lyrics": [
   {
    "pt": "[Coro] Foi na Bahia que eu mandei fazer\nFoi na Bahia que eu mandei preparar\nMeu patuá, meu pai, meu patuá\nMeu patuá para me proteger",
    "en": "[Chorus] It was in Bahia that I had it made\nIt was in Bahia that I had it prepared\nMy patuá, my father, my patuá\nMy patuá, to protect me"
   },
   {
    "pt": "Fui convidado pra uma roda de Gigante\nCom dois pandeiros e três berimbaus\nE um atabaque tocando maneiro e sereno\nÉ a roda que já vai começar",
    "en": "I was invited to a Gigante roda\nWith two pandeiros and three berimbaus\nAnd an atabaque playing smoothly and serenely\nThe roda is about to begin"
   },
   {
    "pt": "[Coro] Foi na Bahia que eu mandei fazer\nFoi na Bahia que eu mandei preparar\nMeu patuá, meu pai, meu patuá\nMeu patuá para me proteger",
    "en": "[Chorus] It was in Bahia that I had it made\nIt was in Bahia that I had it prepared\nMy patuá, my father, my patuá\nMy patuá, to protect me"
   },
   {
    "pt": "Era domingo, era um dia de oferendas\nE eu levei flores pra Iemanjá\nFui celebrar Janaína, rainha menina\nIemanjá que é a dona do mar",
    "en": "It was Sunday, a day for offerings\nAnd I brought flowers to Iemanjá\nI went to celebrate Janaína, the young queen\nIemanjá, who is mistress of the sea"
   },
   {
    "pt": "[Coro] Foi na Bahia que eu mandei fazer\nFoi na Bahia que eu mandei preparar\nMeu patuá, meu pai, meu patuá\nMeu patuá para me proteger",
    "en": "[Chorus] It was in Bahia that I had it made\nIt was in Bahia that I had it prepared\nMy patuá, my father, my patuá\nMy patuá, to protect me"
   },
   {
    "pt": "E na Bahia um mestre velho mandingueiro\nAbriu a roda, fazendo uma louvação\nCantou bem forte o lamento\nMe dando a bênção\nEra a hora de eu sair pra jogar",
    "en": "And in Bahia, an old master of mandinga\nOpened the roda with a song of praise\nHe sang the lament loudly\nGiving me his blessing\nIt was time for me to step out and play"
   },
   {
    "pt": "[Coro] Foi na Bahia que eu mandei fazer\nFoi na Bahia que eu mandei preparar\nMeu patuá, meu pai, meu patuá\nMeu patuá para me proteger",
    "en": "[Chorus] It was in Bahia that I had it made\nIt was in Bahia that I had it prepared\nMy patuá, my father, my patuá\nMy patuá, to protect me"
   },
   {
    "pt": "Meu patuá é meu berimbau sagrado\nÉ minha vida e também o meu cantar\nÉ os meus amigos sorrindo\nSempre junto comigo, na volta que o mundo dá",
    "en": "My patuá is my sacred berimbau\nIt is my life and also my song\nIt is my friends smiling\nAlways together with me, as the world turns"
   },
   {
    "pt": "[Coro] Foi na Bahia que eu mandei fazer\nFoi na Bahia que eu mandei preparar\nMeu patuá, meu pai, meu patuá\nMeu patuá para me proteger",
    "en": "[Chorus] It was in Bahia that I had it made\nIt was in Bahia that I had it prepared\nMy patuá, my father, my patuá\nMy patuá, to protect me"
   }
  ],
  "recordings": [
   {
    "label": "Centro Cultural Ìyá Capoeira Brasil",
    "url": "https://www.youtube.com/watch?v=V-G70aJVZ-8"
   },
   {
    "label": "The Capoeira Cafe · Mestre Casquinha",
    "url": "https://www.youtube.com/watch?v=7PDWrqPXPNI"
   }
  ],
  "source": {
   "label": "The Capoeira Cafe",
   "url": "https://www.capoeira.cafe/meu-patua-mestre-casquinha/"
  }
 },
 {
  "title": "Tava na beira da praia, vendo o que a maré fazia",
  "description": "Corrido",
  "lyrics": [
   {
    "pt": "Tava na beira da praia\nVendo o que a maré fazia\nTava na beira da praia\nVendo o que a maré fazia\nTava na beira da praia\nVendo o que a maré fazia",
    "en": "I was at the edge of the beach\nWatching what the tide did\nI was at the edge of the beach\nWatching what the tide did\nI was at the edge of the beach\nWatching what the tide did"
   },
   {
    "pt": "Quando eu ia, ela voltava\nQuando eu voltava, ela ia",
    "en": "When I went out, it came back\nWhen I came back, it went out"
   }
  ],
  "recordings": [
   {
    "label": "Jean Cori",
    "url": "https://www.youtube.com/watch?v=Bjdz0F34GGQ"
   },
   {
    "label": "Mestre Chorão · with lyrics",
    "url": "https://www.youtube.com/watch?v=eloAY1xDUi8"
   },
   {
    "label": "Tambor do Meu Povo",
    "url": "https://www.youtube.com/watch?v=fDAaW0MehwM"
   }
  ],
  "source": {
   "label": "Capoeira Songs Blogspot",
   "url": "http://capoeira-songs.blogspot.com/2024/11/tava-na-beira-da-praia-vendo-o-que-mare.html"
  }
 },
 {
  "title": "Tem Areia (No Fundo do Mar)",
  "description": "Corrido",
  "lyrics": [
   {
    "pt": "[Coro] Tem areia, tem areia\nTem areia\nNo fundo do mar\nTem areia",
    "en": "[Chorus] There is sand, there is sand\nThere is sand\nAt the bottom of the sea\nThere is sand"
   },
   {
    "pt": "No fundo do mar tem pedra\nDebaixo da pedra tem areia\nOnde mora minha mãe\nMinha mãe linda sereia",
    "en": "At the bottom of the sea there is rock\nUnder the rock there is sand\nWhere my mother lives\nMy beautiful mermaid mother"
   },
   {
    "pt": "[Coro] Tem areia, tem areia\nTem areia\nNo fundo do mar\nTem areia",
    "en": "[Chorus] There is sand, there is sand\nThere is sand\nAt the bottom of the sea\nThere is sand"
   },
   {
    "pt": "No fundo do mar tem pedra\nDebaixo da pedra tem areia\nOnde mora Janaina\nIemanjá linda sereia",
    "en": "At the bottom of the sea there is rock\nUnder the rock there is sand\nWhere Janaina lives\nBeautiful mermaid Iemanjá"
   },
   {
    "pt": "[Coro] Tem areia, tem areia\nTem areia\nNo fundo do mar\nTem areia",
    "en": "[Chorus] There is sand, there is sand\nThere is sand\nAt the bottom of the sea\nThere is sand"
   }
  ],
  "recordings": [
   {
    "label": "Músicas e Histórias da Capoeira",
    "url": "https://www.youtube.com/watch?v=HrK3aBWdlZw"
   },
   {
    "label": "Joga Muito Capoeira",
    "url": "https://www.youtube.com/watch?v=y5rhA-PmvW4"
   },
   {
    "label": "La Laue Capoeira",
    "url": "https://www.youtube.com/watch?v=fSMlmXlGqdI"
   }
  ],
  "source": {
   "label": "Capoeira Aché Brasil Calgary",
   "url": "https://capoeiraabc.com/2019/07/08/tem-areia-no-fundo-do-mar/"
  }
 },
 {
  "title": "Vim no navio de Aruanda",
  "description": "Corrido",
  "lyrics": [
   {
    "pt": "[Cantiga] Vim no navio de Aruanda, Aruanda ê\nVim no navio de Aruanda, Aruanda á\nPorque me trouxeram de Aruanda\nPra que me trouxeram de Aruanda\nVim no navio de Aruanda, Aruanda ê",
    "en": "[Chant] I came on a ship from Aruanda, Aruanda ê\nI came on a ship from Aruanda, Aruanda á\nWhy did they bring me from Aruanda?\nWhat did they bring me from Aruanda for?\nI came on a ship from Aruanda, Aruanda ê"
   }
  ],
  "recordings": [
   {
    "label": "Tony Angola · Capoeira Angola Comunidade",
    "url": "https://www.youtube.com/watch?v=tZe6VaEJbBg"
   }
  ],
  "source": {
   "label": "Capoeira Aché Brasil Calgary",
   "url": "https://capoeiraabc.com/2019/01/14/vim-no-navio-de-aruanda-aruanda-e/"
  }
 },
 {
  "title": "Vou lá pra beira do mar",
  "description": "Corrido",
  "lyrics": [
   {
    "pt": "[Coro] Vou lá pra beira do mar\nBerimbau tocou\nChamou pra jogar",
    "en": "[Chorus] I’m going down to the seashore\nThe berimbau sounded\nIt called me to play"
   },
   {
    "pt": "Berimbau, por que me chama?\nPor que mandou me chamar?\nQuando escuto o seu chamado\nEu vou pra qualquer lugar",
    "en": "Berimbau, why do you call me?\nWhy did you send for me?\nWhen I hear your call\nI’ll go anywhere"
   },
   {
    "pt": "Berimbau tocou na roda\nFez meu corpo arrepiar\nSó quem joga capoeira\nSabe a vontade que dá",
    "en": "The berimbau sounded in the roda\nIt made my body shiver\nOnly those who play capoeira\nKnow the urge it brings"
   },
   {
    "pt": "Ai, meu Deus, se eu pudesse\nSer dono das Três Marias\nDava uma a Mestre Bimba\nA outra a Mestre Pastinha\nE a estrela que sobrasse\nEu guardava pra ser minha",
    "en": "Oh my God, if only I could\nOwn the Three Marys\nI’d give one to Mestre Bimba\nAnother to Mestre Pastinha\nAnd the star that remained\nI’d keep as my own"
   }
  ],
  "recordings": [
   {
    "label": "Dono das três estrelas",
    "url": "https://www.youtube.com/watch?v=HrJ_YGwiu58"
   }
  ],
  "source": {
   "label": "Capoeira Lyrics · “Dono das estrelas”",
   "url": "https://capoeiralyrics.info/songs/dono-das-estrelas.html"
  }
 },
 {
  "title": "Vou mandar lecô, cajuê",
  "description": "Corrido",
  "lyrics": [
   {
    "pt": "[Introdução opcional] Seu Capoeira, que aconteceu\nNaquela roda em noite de lua\nDeu meia-lua, levou cabeçada\nMeu camarada, pode acreditar\nPois nessa roda foi uma beleza\nNa certeza que eu vim de lá\nDaquela terra muito abençoada\nÉ da Bahia que eu vou falar",
    "en": "[Optional introduction] Capoeirista, what happened\nIn that roda on a moonlit night?\nHe gave a meia-lua and took a headbutt\nMy friend, you can believe it\nBecause that roda was a beautiful thing\nI know for certain, because I came from there\nFrom that very blessed land\nIt’s Bahia that I’m going to speak about"
   },
   {
    "pt": "Vou mandar lecô cajuê\nVou mandar loiá\nVou mandar lecô cajuê\nVou mandar loiá",
    "en": "I’ll call out lecô, cajuê\nI’ll call out loiá\nI’ll call out lecô, cajuê\nI’ll call out loiá"
   },
   {
    "pt": "[Coro] Vou mandar lecô cajuê\nVou mandar loiá\nVou mandar lecô cajuê\nVou mandar loiá",
    "en": "[Chorus] I’ll call out lecô, cajuê\nI’ll call out loiá\nI’ll call out lecô, cajuê\nI’ll call out loiá"
   },
   {
    "pt": "[Chamada] Vou mandar lecô\nVou mandar loiá\nVou mandar lecô\nVou mandar loiá",
    "en": "[Call] I’ll call out lecô\nI’ll call out loiá\nI’ll call out lecô\nI’ll call out loiá"
   },
   {
    "pt": "[Resposta após cada linha] Cajuê\nCajuê\nCajuê\nCajuê",
    "en": "[Response after each line] Cajuê\nCajuê\nCajuê\nCajuê"
   }
  ],
  "recordings": [
   {
    "label": "Michigan Center for Capoeira",
    "url": "https://www.youtube.com/watch?v=mv8Jr-BHGzg"
   },
   {
    "label": "Vinho Capoeira",
    "url": "https://www.youtube.com/watch?v=j8KM-gQG7Y4"
   }
  ],
  "source": {
   "label": "Capoeira Aché Brasil Calgary",
   "url": "https://capoeiraabc.com/2018/02/21/song-1-2-3-2-2-2-2-2-2-2-2-2-2-2-2/"
  }
 }
]
